/* globals wNumb */

import debounce from 'lodash/debounce';

import { initBootstrapSelect } from '../../Shared/js/vendor/deferred';

// TODO: Enable eslint rule and fix the code
/* eslint-disable eqeqeq */

async function main() {
    // HACK: async/await doesn't work with jQuery here for some reason
    await initBootstrapSelect();

    var filtersModal = null;
    var modalBackup = null;
    var modalDataBackup = null;
    var modalData = null;

    var filtersModalController = {
        handleNotification: function (notification, data) {
            if (notification === 'ChangeCarriers') {
                filtersModal.data('select-line', 'carriers');
                filtersModal.modal('show');
            }

            if (notification === 'ChangeAdvanced') {
                filtersModal.data('select-line', 'advanced');
                filtersModal.modal('show');
            }

            if (notification === 'AddLine') {
                filtersModal.data('select-line', -1);
                filtersModal.modal('show');
            }

            if (notification === 'EditLine') {
                filtersModal.data('select-line', data.line);
                filtersModal.modal('show');
            }

            if (notification === 'LineChanged') {
                if (data.line > 0) {
                    if (data.isByo === true) {
                        modalData.lines[data.line - 1].simOnly = true;
                        modalData.lines[data.line - 1].allowPhoneSub = false;
                        filtersModalController.search();
                    } else if (data.showClosestMatch === true) {
                        modalData.lines[data.line - 1].allowPhoneSub = true;
                        filtersModalController.search();
                    } else if (data.showClosestMatch === false) {
                        modalData.lines[data.line - 1].allowPhoneSub = false;
                        filtersModalController.search();
                    } else if (data.isRemove === true) {
                        modalData.lines.splice(data.line - 1, 1);
                        filtersModalController.search();
                    }
                }
            }

            if (notification === 'FilterChanged') {
                WhistleOut.notifications.remove(filtersModalController.handleNotification);
            }
        },

        bind: function () {
            filtersModal.on('show.bs.modal',
                function () {
                    filtersModalController.loadClientSideData();
                    filtersModalController.initTabs();
                    filtersModalController.bindLine(filtersModal.find('div#tab-line-1'), modalData.lines[0]);
                    filtersModalController.showTab(filtersModal.data('select-line'));

                    filtersModal.find('button[name="modal-search"]').click(function () {
                        filtersModalController.search();
                    });
                    filtersModal.find('button[name="modal-cancel"]').click(function () {
                        filtersModal.modal('hide');
                    });
                    filtersModal.on('hidden.bs.modal',
                        function () {
                            wo$('div[data-toggle="popover"]').each(function () {
                                var $this = wo$(this);
                                $this.popover('hide');
                            });

                            filtersModal.html(modalBackup);
                            WhistleOut.setLookupData(filtersModal.parent(), wo$.extend(true, {}, modalDataBackup));

                            filtersModal.off('hidden.bs.modal');
                        });
                    filtersModal.on('hide.bs.modal',
                        function () {
                            wo$('[data-show-byo-button]').popover('hide');
                            filtersModal.off('hide.bs.modal');
                        });
                    filtersModal.find('#select-all-suppliers').click(function () {
                        wo$.each(modalData.suppliers,
                            function (index, supplier) {
                                supplier.isChecked = true;
                            });
                        wo$.each(modalData.networks,
                            function (index, network) {
                                network.isChecked = true;
                                filtersModal.find('#network-' + network.id).prop('checked', true);
                            });
                        filtersModal.find('#personal-checkbox').prop('checked', true);
                        filtersModal.find('#business-checkbox').prop('checked', true);
                        filtersModalController.bindSuppliers(filtersModal, modalData.suppliers);
                    });
                    filtersModal.find('#unselect-all-suppliers').click(function () {
                        wo$.each(modalData.suppliers,
                            function (index, supplier) {
                                supplier.isChecked = false;
                            });
                        filtersModalController.bindSuppliers(filtersModal, modalData.suppliers);
                    });
                    filtersModal.find('#personal-checkbox').click(function () {
                        var showPersonal = filtersModal.find('#personal-checkbox').is(':checked');
                        var showBusiness = filtersModal.find('#business-checkbox').is(':checked');

                        wo$.each(modalData.suppliers,
                            function (index, supplier) {
                                if (!showBusiness && !showPersonal) {
                                    supplier.isChecked = false;
                                } else if (showPersonal && supplier.isPersonal) {
                                    supplier.isChecked = true;
                                } else if (!showPersonal && (supplier.isPersonal && !supplier.isBusiness)) {
                                    supplier.isChecked = false;
                                }
                            });
                        filtersModalController.bindSuppliers(filtersModal, modalData.suppliers);

                        if (showPersonal && showBusiness || !showPersonal && !showBusiness) {
                            modalData.customerType = null;
                        } else if (showPersonal) {
                            modalData.customerType = 'Personal';
                        } else if (showBusiness) {
                            modalData.customerType = 'Business';
                        }
                    });
                    filtersModal.find('#business-checkbox').click(function () {
                        var showPersonal = filtersModal.find('#personal-checkbox').is(':checked');
                        var showBusiness = filtersModal.find('#business-checkbox').is(':checked');

                        wo$.each(modalData.suppliers,
                            function (index, supplier) {
                                if (!showBusiness && !showPersonal) {
                                    supplier.isChecked = false;
                                } else if (showBusiness && supplier.isBusiness) {
                                    supplier.isChecked = true;
                                } else if (!showBusiness && supplier.isBusiness & !supplier.isPersonal) {
                                    supplier.isChecked = false;
                                }
                            });
                        filtersModalController.bindSuppliers(filtersModal, modalData.suppliers);

                        if (showPersonal && showBusiness || !showPersonal && !showBusiness) {
                            modalData.customerType = null;
                        } else if (showPersonal) {
                            modalData.customerType = 'Personal';
                        } else if (showBusiness) {
                            modalData.customerType = 'Business';
                        }
                    });

                    filtersModal.find('[data-network-checkbox]').click(function () {
                        var networkId = wo$(this).data('network-checkbox');
                        var isChecked = wo$(this).is(':checked');

                        wo$.each(modalData.networks,
                            function (index, network) {
                                if (network.id === networkId) {
                                    network.isChecked = isChecked;
                                }
                            });

                        var suppliersOnSelectedNetwork = modalData.suppliers.filter(function (s) {
                            return s.networkIds.indexOf(networkId) > -1;
                        });

                        if (isChecked) {
                            wo$.each(suppliersOnSelectedNetwork,
                                function (index, supplier) {
                                    supplier.isChecked = true;
                                });
                        } else {
                            var otherSelectedNetworkIds =
                                    wo$.map(modalData.networks.filter(function (n) { return n.isChecked; }),
                                        function (n) { return n.id; });
                            wo$.each(suppliersOnSelectedNetwork,
                                function (index, supplier) {
                                    var hasOtherNetworks = supplier.networkIds.filter(function (n) {
                                        return otherSelectedNetworkIds.indexOf(n) !== -1;
                                    }).length > 0;
                                    if (!hasOtherNetworks) {
                                        supplier.isChecked = isChecked;
                                    }
                                });
                        }

                        filtersModalController.bindSuppliers(filtersModal, modalData.suppliers);
                    });

                    if (modalData.lines.length >= modalData.maxLines - 1) {
                        filtersModal.find('#add-line-button').addClass('hidden');
                    }

                    if (modalData.lines.length === 1) {
                        filtersModal.find('[data-remove-line-span]').addClass('hidden');
                    }
                });

            WhistleOut.notifications.add(filtersModalController.handleNotification);
        },

        initTabs: function () {
            filtersModalController.showValidTabs();
            filtersModalController.bindGenericSliders();

            filtersModal.find('#tabs a[data-toggle="tab"]').on('shown.bs.tab',
                function (e) {

                    var sourceTab = wo$(e.relatedTarget);
                    var targetTab = wo$(e.currentTarget);

                    var sourceLink = sourceTab.attr('href');
                    if (sourceLink.indexOf('#tab-line-') >= 0) {
                        filtersModal.find('div' + sourceLink).empty();
                    }

                    var targetLink = targetTab.attr('href');
                    if (targetLink.indexOf('#tab-line-') >= 0) {

                        filtersModalController.gotoTab(targetLink);

                    } else if (targetLink.indexOf('#tab-add-line') >= 0 && WhistleOut.phonePickerController) {
                        var phonePickerTab = filtersModal.find('#tab-phone-picker');
                        var addLineTab = filtersModal.find('#tab-add-line');
                        var pickerParent = filtersModal.find('#picker-parent');

                        addLineTab.append(pickerParent);

                        WhistleOut.phonePickerController.init(false,
                            function (selectedPhone) {
                                WhistleOut.scrollTo(0);
                                filtersModalController.addNewLine(selectedPhone);
                                WhistleOut.phonePickerController.cleanup();
                                phonePickerTab.append(pickerParent);
                            },
                            addLineTab);

                    }

                    var tabContent = filtersModal.find('div' + targetLink);
                    WhistleOut.applyPopover(tabContent);
                });
        },

        loadClientSideData: function () {
            modalDataBackup = wo$.extend(true,
                {},
                WhistleOut.readLookupData(filtersModal.parent().find('#search-modal-client-side-data-container')));
            modalData = WhistleOut.readLookupData(filtersModal.parent().find('#search-modal-client-side-data-container'));
        },

        bindGenericSliders: function () {
            filtersModalController.bindMaxPhoneUpfrontSlider(filtersModal, modalData.maxPhoneUpfrontSlider);
            filtersModalController.bindSpendSlider(filtersModal, modalData.monthlySpendSlider);
            filtersModalController.bindSuppliers(filtersModal, modalData.suppliers);
            filtersModalController.bindCurrentlyWith(filtersModal, modalData);
            filtersModalController.bindSortExpressions(filtersModal, modalData);
            filtersModalController.bindPrepaidExpiry(filtersModal, modalData.prepaidExpirySlider);
            filtersModalController.bindPlanType(filtersModal, modalData);
            filtersModalController.bindSeniorsMilitaryResponders(filtersModal, modalData);
            filtersModalController.bindOtherOptions(filtersModal, modalData);
            filtersModalController.bindEligibility(filtersModal, modalData);
        },


        addNewLine: function (selectedPhone) {
            var newLine = wo$.extend(true, {}, modalData.lineTemplate);
            var lineNum = modalData.lines.length + 1;
            newLine.lineNumber = lineNum;
            newLine.selectedPhone = selectedPhone;
            modalData.lines.push(newLine);
            filtersModalController.showValidTabs();
            filtersModalController.bindLine(filtersModal.find('div#tab-line-' + lineNum), newLine);
            filtersModalController.showTab(lineNum);
            filtersModalController.selectPhone(filtersModal.find('div#tab-line-' + lineNum),
                newLine,
                selectedPhone,
                true);

            if (lineNum >= modalData.maxLines) {
                filtersModal.find('#add-line-button').addClass('hidden');
            }

            if (modalData.lines.length === 1) {
                filtersModal.find('[data-remove-line-span]').addClass('hidden');
            } else {
                filtersModal.find('[data-remove-line-span]').removeClass('hidden');
            }
        },

        gotoTab: function (tabLink) {
            var targetDiv = filtersModal.find('div' + tabLink);
            var lineNumber = parseInt(tabLink.split('-').pop());
            filtersModalController.bindLine(targetDiv, modalData.lines[lineNumber - 1]);
        },

        removePhone: function (tabContainer) {
            var tabId = tabContainer.attr('id');
            if (tabId && tabId.indexOf('-') >= 0) {
                var lineNum = parseInt(tabId.split('-').pop());
                var lineData = modalData.lines[lineNum - 1];
                filtersModalController.selectPhone(tabContainer, lineData, null);
                tabContainer.find('[data-has-5g]').hide();
            }
        },

        removeLine: function (tabId) {
            if (tabId && tabId.indexOf('-') >= 0 && modalData.lines.length > 1) {
                var lineNum = parseInt(tabId.split('-').pop());
                modalData.lines.splice(lineNum - 1, 1);
                filtersModalController.showValidTabs();
                filtersModalController.bindLine(filtersModal.find('div#tab-line-1'), modalData.lines[0]);
                filtersModalController.showTab(lineNum - 1);

                if (modalData.lines.length <= modalData.maxLines) {
                    filtersModal.find('#add-line-button').removeClass('hidden');
                }

                if (modalData.lines.length > 1) {
                    filtersModal.find('[data-remove-line-span]').removeClass('hidden');
                } else {
                    filtersModal.find('[data-remove-line-span]').addClass('hidden');
                }
            }
        },

        bindLine: function (lineContainer, lineData) {
            var lineTemplateHtml = filtersModal.find('div#tab-line-template').html();
            lineTemplateHtml = lineTemplateHtml.replace(/{{LINENUMBER}}/g, lineData.lineNumber);
            lineContainer.html(lineTemplateHtml);

            wo$.each(lineContainer.find('select option[data-max-lines]'),
                function () {
                    var maxLines = wo$(this).data('max-lines');
                    if (maxLines < modalData.lines.length) {
                        wo$(this).hide();
                    } else {
                        wo$(this).show();
                    }
                });

            filtersModalController.bindMinutesSlider(lineContainer, lineData.minutesSlider);
            filtersModalController.bindCallsSlider(lineContainer, lineData.callsSlider);
            filtersModalController.bindDataSlider(lineContainer, lineData.dataSlider);
            filtersModalController.bindMessagesSlider(lineContainer, lineData.messagesSlider);
            filtersModalController.bindPhoneSub(lineContainer, lineData);
            filtersModalController.bindTetherPhone(lineContainer, lineData);
            filtersModalController.bindPhone(lineContainer, lineData);
            filtersModalController.bindRemovePhone();
            filtersModalController.bindRemoveLine();

            WhistleOut.applyPopover(lineContainer);
        },

        bindRemovePhone: function () {
            filtersModal.find('[data-remove-phone-button]').click(function () {
                var tabContainer = wo$(this).parentsUntil('.tab-pane').parent();
                if (tabContainer) {
                    filtersModalController.removePhone(tabContainer);
                }
            });
        },

        bindRemoveLine: function () {
            filtersModal.find('[data-remove-line-button]').click(function () {
                var tabId = wo$(this).parentsUntil('.tab-pane').parent().attr('id');
                filtersModalController.removeLine(tabId);
            });
        },

        showTab: function (selectLine) {
            if (selectLine && selectLine > 0) {
                var tabToShow = filtersModal.find('a[href="#tab-line-' + selectLine + '"]');
                tabToShow.tab('show');
                filtersModal.data('select-line', null);
            } else if (selectLine === -1) {
                var addLineTab = filtersModal.find('a[href="#tab-add-line"]');
                addLineTab.tab('show');
                filtersModal.data('select-line', null);
            } else if (selectLine === 'carriers') {
                var carriersTab = filtersModal.find('a[href="#tab-carriers"]');
                carriersTab.tab('show');
                filtersModal.data('select-line', null);
            } else if (selectLine === 'advanced') {
                var advancedTab = filtersModal.find('a[href="#tab-advanced"]');
                advancedTab.tab('show');
                filtersModal.data('select-line', null);
            } else {
                var firstTab = filtersModal.find('a[href="#tab-line-1"]');
                firstTab.tab('show');
                filtersModal.data('select-line', null);
            }
        },

        showValidTabs: function () {
            var linesCount = modalData.lines.length;
            for (var line = 1; line <= modalData.maxLines; line++) {
                const lineTab = filtersModal.find(`a[href="#tab-line-${line}"]`).parent();

                if (line <= linesCount) {
                    lineTab.removeClass('hidden');
                } else if (!lineTab.hasClass('hidden')) {
                    lineTab.addClass('hidden');
                }
            }
        },

        bindMinutesSlider: function (container, sliderConfig, rebind) {
            if (sliderConfig) {
                WhistleOut.createSlider(container.find('[data-modal-minutes-slider]'),
                    container.find('[data-modal-minutes-text]'),
                    sliderConfig,
                    wNumb({ decimals: 0 }),
                    null,
                    rebind);
            }
        },

        bindCallsSlider: function (container, sliderConfig, rebind) {
            if (sliderConfig) {
                WhistleOut.createSlider(container.find('[data-modal-calls-slider]'),
                    container.find('[data-modal-calls-text]'),
                    sliderConfig,
                    wNumb({ decimals: 0 }),
                    null,
                    rebind);
            }
        },

        bindDataSlider: function (container, sliderConfig, rebind) {
            WhistleOut.createSlider(container.find('[data-modal-data-slider]'),
                container.find('[data-modal-data-text]'),
                sliderConfig,
                wNumb({ decimals: 0 }),
                null,
                rebind);
        },

        bindMessagesSlider: function (container, sliderConfig, rebind) {
            WhistleOut.createSlider(container.find('[data-modal-messages-slider]'),
                container.find('[data-modal-messages-text]'),
                sliderConfig,
                wNumb({ decimals: 0 }),
                null,
                rebind);
        },

        bindMaxPhoneUpfrontSlider: function (container, sliderConfig, rebind) {
            WhistleOut.createSlider(container.find('[data-modal-maxupfront-slider]'),
                container.find('[data-modal-maxupfront-text]'),
                sliderConfig,
                wNumb({ decimals: 0 }),
                null,
                rebind);
        },

        bindSpendSlider: function (container, sliderConfig) {
            WhistleOut.createDoubleSlider(container.find('[data-modal-monthlyspend-slider]'),
                container.find('[data-modal-monthlyspend-text]'),
                sliderConfig,
                wNumb({ decimals: 0 }),
                null,
                null,
                true);
        },

        bindOtherOptions: function (container, data) {
            var values = [];
            if (data.fullSpeedData)
                values.push('full-speed-data');
            if (data.includeInternationalCalls)
                values.push('international-calls');
            if (data.showDealsOnly)
                values.push('show-deals-only');
            if (data.singleResultPerSupplier)
                values.push('single-result-per-supplier');
            if (data.refurbishedPhones) {
                if (data.refurbishedPhones === 'Include') {
                    values.push('refurb-include');
                } else if (data.refurbishedPhones === 'Exclude') {
                    values.push('refurb-exclude');
                } else if (data.refurbishedPhones === 'Only') {
                    values.push('refurb-only');
                }
            }
            var select = container.find('#other-options');
            WhistleOut.applySelectPicker(select);
            select.selectpicker('val', values);
            WhistleOut.applySelectPickersStyle(container);

            select.off('changed.bs.select').on('changed.bs.select',
                function () {
                    values = select.selectpicker('val');
                    if (select.find('option[value="full-speed-data"]').length > 0) {
                        data.fullSpeedData = values != null && values.indexOf('full-speed-data') > -1;
                    }
                    if (select.find('option[value="international-calls"]').length > 0) {
                        data.includeInternationalCalls = values != null && values.indexOf('international-calls') > -1;
                    }
                    data.showDealsOnly = values != null && values.indexOf('show-deals-only') > -1;
                    data.singleResultPerSupplier = values != null &&
                            values.indexOf('single-result-per-supplier') > -1;
                    if (select.find('option[value="refurb-include"]').length > 0) {
                        if (wo$.inArray('refurb-include', values) > -1) {
                            data.refurbishedPhones = 'Include';
                        } else if (wo$.inArray('refurb-exclude', values) > -1) {
                            data.refurbishedPhones = 'Exclude';
                        } else if (wo$.inArray('refurb-only', values) > -1) {
                            data.refurbishedPhones = 'Only';
                        }
                    }
                });
        },

        bindSuppliers: function (container, suppliers) {
            container.find('.suppliers').each(function () {
                var input = wo$(this);
                var shortUrl = input.attr('id');
                var isChecked = suppliers.filter(function (supplier) { return supplier.shortUrl === shortUrl; })[0].isChecked;
                input.prop('checked', isChecked);

                input.click(function () {
                    var showPersonal = filtersModal.find('#personal-checkbox').is(':checked');
                    var showBusiness = filtersModal.find('#business-checkbox').is(':checked');
                    wo$.each(suppliers,
                        function (index, supplier) {
                            if (shortUrl === supplier.shortUrl) {
                                supplier.isChecked = input.is(':checked');
                                if (supplier.isBusiness && !supplier.isPersonal && !showBusiness && supplier.isChecked) {
                                    filtersModal.find('#business-checkbox').prop('checked', true);
                                }
                                if (supplier.isPersonal && !showPersonal && supplier.isChecked) {
                                    filtersModal.find('#personal-checkbox').prop('checked', true);
                                }
                                wo$.each(modalData.networks,
                                    function (i, n) {
                                        if (supplier.networkIds.filter(function (nid) { return n.id === nid; }).length > 0) {
                                            var networkId = n.id;
                                            if (supplier.isChecked === true) {
                                                n.isChecked = true;
                                                filtersModal.find('#network-' + networkId).prop('checked', true);
                                            }
                                        }
                                    });

                            }
                        });

                    showPersonal = filtersModal.find('#personal-checkbox').is(':checked');
                    showBusiness = filtersModal.find('#business-checkbox').is(':checked');
                    if (showPersonal && showBusiness || !showPersonal && !showBusiness) {
                        modalData.customerType = null;
                    } else if (showPersonal) {
                        modalData.customerType = 'Personal';
                    } else if (showBusiness) {
                        modalData.customerType = 'Business';
                    }
                });

                var showPersonal = filtersModal.find('#personal-checkbox').is(':checked');
                var showBusiness = filtersModal.find('#business-checkbox').is(':checked');
                if (showPersonal && showBusiness || !showPersonal && !showBusiness) {
                    modalData.customerType = null;
                } else if (showPersonal) {
                    modalData.customerType = 'Personal';
                } else if (showBusiness) {
                    modalData.customerType = 'Business';
                }
            });
        },

        bindPhonePriceTypes: function (container, priceTypes, isDisabled) {
            if (!isDisabled) {
                isDisabled = false;
            }

            var select = container.find('select[id^=\'price-type-\']');
            select.prop('disabled', isDisabled);
            WhistleOut.applySelectPicker(select);

            if (!isDisabled) {
                var checkedPriceTypes = priceTypes.filter(function (priceType) {
                    return priceType.isChecked;
                });
                var checkedPriceTypeValues = checkedPriceTypes.map(function (priceType) {
                    return priceType.value;
                });
                select.selectpicker('val', checkedPriceTypeValues);
                WhistleOut.applySelectPickersStyle(container);
                select.off('changed.bs.select').on('changed.bs.select',
                    function () {
                        var values = select.selectpicker('val');
                        wo$(priceTypes).each(function (index, priceType) {
                            priceType.isChecked = values != null && values.indexOf(priceType.value) !== -1;
                        });
                    });
            }

        },

        bindPhoneSub: function (container, lineData, isDisabled) {
            if (!isDisabled) {
                isDisabled = false;
            }
            if (isDisabled) {
                lineData.allowPhoneSub = false;
            }

            var input = container.find('input[id^=\'include-closest-\']');
            input.prop('disabled', isDisabled);
            input.prop('checked', lineData.allowPhoneSub);
            input.click(function () {
                lineData.allowPhoneSub = input.is(':checked');
            });
        },

        bindTetherPhone: function (container, lineData) {
            var input = container.find('input[id^=\'tethering-required-\']');
            input.prop('checked', lineData.tetherPhone);
            input.click(function () {
                lineData.tetherPhone = input.is(':checked');
            });
        },

        bindPhone: function (container, lineData) {

            WhistleOut.applySelectPickersStyle(filtersModal);

            var selectedPhone = lineData.selectedPhone;

            if (selectedPhone) {
                filtersModalController.selectPhone(container,
                    lineData,
                    selectedPhone,
                    null);
            } else {
                if (modalData.lines.length === 1 && !lineData.simOnly) {
                    filtersModalController.selectPhone(container, lineData, -2);
                } else {
                    filtersModalController.selectPhone(container, lineData, -1);
                }
            }

            container.find('[data-select-phone-button]').off().click(function () {
                const phonePickerTab = filtersModal.find('#tab-phone-picker');
                const pickerParent = filtersModal.find('#picker-parent');
                const currentTabParents = wo$(this).parentsUntil('.tab-pane');

                // Select the top parent
                const currentTab = wo$(currentTabParents[currentTabParents.length - 1]);
                currentTab.empty();
                currentTab.append(pickerParent);

                WhistleOut.phonePickerController.init(false,
                    function (selectedPhone) {
                        WhistleOut.scrollTo(0, 500);
                        filtersModalController.selectPhone(container,
                            lineData,
                            selectedPhone,
                            false);
                        WhistleOut.phonePickerController.cleanup();
                        phonePickerTab.append(pickerParent);

                        const currentLineNumber = lineData.lineNumber;
                        filtersModalController.bindLine(filtersModal.find('div#tab-line-' + currentLineNumber), lineData);
                    },
                    currentTab,
                    selectedPhone.byod ? selectedPhone.byod.id : null);

            });
        },

        bindCurrentlyWith: function (container, data) {
            var select = container.find('select[id=\'currently-with\']');
            WhistleOut.applySelectPicker(select);
            var selectedSupplier = data.allSuppliers.filter(function (supplier) {
                return supplier.isChecked === true;
            })[0];

            if (selectedSupplier) {
                filtersModalController.selectCurrentlyWithSupplier(container, data, selectedSupplier.id);
            }

            select.change(function () {
                var selectedId = parseInt(this.value);
                filtersModalController.selectCurrentlyWithSupplier(container, data, selectedId);
            });
        },

        bindSortExpressions: function (container, data) {
            var select = container.find('select[id=\'sort-by\']');
            WhistleOut.applySelectPicker(select);
            var selectedSortExpression = data.sortExpressions.filter(function (sortExpression) {
                return sortExpression.isChecked === true;
            })[0];

            if (selectedSortExpression) {
                filtersModalController.selectSortExpression(container, data, selectedSortExpression.key);
            }

            select.change(function () {
                var selectedKey = this.value;
                filtersModalController.selectSortExpression(container, data, selectedKey);
            });
        },

        bindPlanType: function (container, data) {
            var selectedPlanType = data.planType ? data.planType : '';
            var select = container.find('#plan-type');
            WhistleOut.applySelectPicker(select);
            select.selectpicker('val', selectedPlanType);
            select.change(function () {
                var planType = this.value;
                switch (planType) {
                    case '':
                        data.planTypes = null;
                        WhistleOut.resetDoubleSlider(
                            container.find('[data-modal-prepaidexpiry-slider]'), 
                            data.prepaidExpirySlider
                        );
                        break;
                    default:
                        data.planTypes = new Array(planType);
                        break;
                }
            });
        },

        loadSeniorsMilitaryResponders: function (container, data) {
            var select = container.find('#seniors-military-responders');
            if (select.length > 0) {
                var selectedValues = [];
                if (data.includeSeniors === true) {
                    selectedValues.push('seniors');
                } else if (data.includeSeniors === false) {
                    selectedValues.push('noSeniors');
                }

                if (data.includeMilitary === true) {
                    selectedValues.push('military');
                } else if (data.includeMilitary === false) {
                    selectedValues.push('noMilitary');
                }

                if (data.includeFirstResponders === true) {
                    selectedValues.push('firstResponders');
                } else if (data.includeFirstResponders === false) {
                    selectedValues.push('noFirstReponders');
                }

                WhistleOut.applySelectPicker(select);
                select.selectpicker('val', selectedValues);
            }
        },
        bindEligibility: function (container, data) {
            var values = data.eligibility ? data.eligibility.split(',') : '';
            var select = container.find('#discount-eligibility');
            WhistleOut.applySelectPicker(select);
            select.selectpicker('val', values);
            WhistleOut.applySelectPickersStyle(container);
            select.on('changed.bs.select', function() {
                var selectedOptions = wo$(this).selectpicker('val');
                data.eligibility = selectedOptions == null ? null : 'none,'+ selectedOptions;
            });
        },
        bindSeniorsMilitaryResponders: function (container, data) {
            var select = container.find('#seniors-military-responders');
            if (select.length > 0) {
                filtersModalController.loadSeniorsMilitaryResponders(container, data);

                select.on('changed.bs.select', function (e, clickedIndex, isSelected) {
                    var selectedOptions = wo$(this).selectpicker('val');
                    if (wo$.inArray('seniors', selectedOptions) > -1) {
                        data.includeSeniors = true;
                    } else if (wo$.inArray('noSeniors', selectedOptions) > -1) {
                        data.includeSeniors = false;
                    } else {
                        data.includeSeniors = null;
                    }

                    if (wo$.inArray('military', selectedOptions) > -1) {
                        data.includeMilitary = true;
                    } else if (wo$.inArray('noMilitary', selectedOptions) > -1) {
                        data.includeMilitary = false;
                    } else {
                        data.includeMilitary = null;
                    }

                    if (wo$.inArray('firstResponders', selectedOptions) > -1) {
                        data.includeFirstResponders = true;
                    } else if (wo$.inArray('noFirstReponders', selectedOptions) > -1) {
                        data.includeFirstResponders = false;
                    } else {
                        data.includeFirstResponders = null;
                    }

                    if (isSelected == true) {
                        if (clickedIndex == 0) { // Senior selected
                            data.includeMilitary = null;
                            data.includeFirstResponders = null;
                        } else if (clickedIndex == 1) { // Senior excluded
                            if (data.includeMilitary === true) {
                                data.includeMilitary = null;
                            }
                            if (data.includeFirstResponders === true) {
                                data.includeFirstResponders = null;
                            }
                        }
                        if (clickedIndex == 2) { // military selected
                            data.includeSeniors = null;
                            data.includeFirstResponders = null;
                        } else if (clickedIndex == 3) { // military excluded
                            if (data.includeSeniors === true) {
                                data.includeSeniors = null;
                            }
                            if (data.includeFirstResponders === true) {
                                data.includeFirstResponders = null;
                            }
                        }
                        if (clickedIndex == 4) { // first responders selected
                            data.includeSeniors = null;
                            data.includeMilitary = null;
                        } else if (clickedIndex == 5) { // first responders excluded
                            if (data.includeSeniors === true) {
                                data.includeSeniors = null;
                            }
                            if (data.includeMilitary === true) {
                                data.includeMilitary = null;
                            }
                        }
                    }

                    filtersModalController.loadSeniorsMilitaryResponders(container, data);
                });
            }
        },

        bindPrepaidExpiry: function (container, sliderConfig) {
            WhistleOut.createDoubleSlider(container.find('[data-modal-prepaidexpiry-slider]'),
                container.find('[data-modal-prepaidexpiry-text]'),
                sliderConfig,
                wNumb({ decimals: 0 }),
                () => {
                    let dropdownValue = 'prepaid';
                    if(sliderConfig.currentPeg1 == sliderConfig.pegs[0] && sliderConfig.currentPeg2 == sliderConfig.pegs[sliderConfig.pegs.length - 1])
                    {
                        dropdownValue = '';
                    }
                    WhistleOut.setDropdownIndex(container.find('select[id=\'plan-type\']'), dropdownValue);
                }
            );
        },

        // TODO: Try reducing complexity
        // eslint-disable-next-line complexity
        selectPhone: function (container, lineData, phone, isNew) {
            if (!phone) {
                phone = modalData.noPhoneTemplate;
            }

            lineData.selectedPhone = phone;

            var selectPhoneText = filtersModal.find('[data-select-phone-button]').data('change-phone-text');

            if (lineData.selectedPhone.id === -2) { // No Phone Selected
                container.find('[data-selected-phone-info]').hide();
                container.find('[data-byod-headline]').hide();
                selectPhoneText = filtersModal.find('[data-select-phone-button]').data('add-phone-text');
                filtersModal.find('[data-remove-phone-span]').addClass('hidden');
            }
            else if (lineData.selectedPhone.byod) { // BYOD
                container.find('[data-selected-phone-info]').show();
                container.find('[data-byod-headline]').show();
                container.find('[data-model-info]').show();
                container.find('[data-phone-name]').text(lineData.selectedPhone.byod.name);
                container.find('[data-model-number]').text(lineData.selectedPhone.byod.modelName);

                if (lineData.selectedPhone.byod.is5GCapable) {
                    container.find('[data-has-5g]').show();
                } else {
                    container.find('[data-has-5g]').hide();
                }

                if (lineData.lineNumber === 1 && modalData.lines.length === 1) {
                    filtersModal.find('[data-remove-phone-span]').removeClass('hidden');
                } else {
                    filtersModal.find('[data-remove-phone-span]').addClass('hidden');
                }
            } else if ( lineData.selectedPhone.id > -1) { // Phone Selected
                container.find('[data-selected-phone-info]').show();
                container.find('[data-byod-headline]').hide();
                container.find('[data-model-info]').hide();
                container.find('[data-phone-name]').text(lineData.selectedPhone.name);

                if (lineData.selectedPhone.is5GCapable) {
                    container.find('[data-has-5g]').show();
                } else {
                    container.find('[data-has-5g]').hide();
                }

                if (lineData.lineNumber === 1 && modalData.lines.length === 1) {
                    filtersModal.find('[data-remove-phone-span]').removeClass('hidden');
                } else {
                    filtersModal.find('[data-remove-phone-span]').addClass('hidden');
                }
            }

            filtersModal.find('[data-select-phone-button]').text(selectPhoneText);

            var phoneImage = container.find('img[id^="phone-image-"]');
            if (lineData.selectedPhone) {
                if (lineData.selectedPhone.byod) {
                    phoneImage.attr('src', lineData.selectedPhone.byod.imageUrl.large);
                } else {
                    phoneImage.attr('src', lineData.selectedPhone.imageUrl.large);
                }
            } else {
                phoneImage.attr('src', lineData.selectedPhone.byod.imageUrl.large);
            }

            var hasPhone = lineData.selectedPhone && lineData.selectedPhone.id > -1;
            var selectedPriceTypes = lineData.phonePriceTypes.filter(function (priceType) {
                return priceType.isChecked === true;
            });
            if (hasPhone && (!selectedPriceTypes || selectedPriceTypes.length <= 0)) {
                wo$.each(lineData.phonePriceTypes,
                    function (index, priceType) {
                        priceType.isChecked = true;
                    });
            }

            if (lineData.selectedPhone.id === -1) {
                lineData.simOnly = true;
            } else {
                lineData.simOnly = false;
            }

            filtersModalController.bindPhonePriceTypes(container, lineData.phonePriceTypes, !hasPhone);

            if (isNew) {
                var allowPhoneSub = hasPhone && modalData.lines.length > 1 && lineData.selectedPhone.suppliersCount < 3;
                if (allowPhoneSub && lineData.lineNumber === 1 && !modalData.autoPhoneSubstitutionLine1) {
                    allowPhoneSub = false;
                }
                if (allowPhoneSub === true && !lineData.allowPhoneSub) {
                    lineData.allowPhoneSub = true;
                } else {
                    lineData.allowPhoneSub = false;
                }
            }

            filtersModalController.bindPhoneSub(container, lineData, !hasPhone);
        },

        selectCurrentlyWithSupplier: function (container, data, supplierId) {

            if (!supplierId || !WhistleOut.isNumber(supplierId)) {
                supplierId = -1;
            }

            wo$.each(data.allSuppliers,
                function (index, supplier) {
                    supplier.isChecked = false;
                });

            var selectedSupplier = data.allSuppliers.filter(function (supplier) {
                return supplier.id === supplierId;
            })[0];

            if (selectedSupplier) {
                selectedSupplier.isChecked = true;
                var select = container.find('select[id=\'currently-with\']');
                select.selectpicker('val', selectedSupplier.id);
            }
        },

        selectSortExpression: function (container, data, key) {
            if (!key) {
                key = -1;
            }

            wo$.each(data.sortExpressions,
                function (index, sortExpression) {
                    sortExpression.isChecked = false;
                });

            var selectedSortExpression = data.sortExpressions.filter(function (sortExpression) {
                return sortExpression.key === key;
            })[0];

            if (selectedSortExpression) {
                selectedSortExpression.isChecked = true;
                var select = container.find('select[id=\'sort-by\']');
                select.selectpicker('val', selectedSortExpression.key);
            }
        },

        // TODO: Try reducing cyclomatic complexity and enable the eslint rule
        // eslint-disable-next-line complexity
        search: function () {
            filtersModal.find('button[name="modal-search"]').attr('disabled', 'disabled');
            filtersModal.find('button[name="modal-cancel"]').attr('disabled', 'disabled');
            filtersModal.find('span[name="modal-search-spinner"]').show();

            var queryData = WhistleOut.readLookupData(wo$('[data-search-criteria]'));
            queryData.lines = [];

            wo$.each(modalData.lines,
                function (index, line) {

                    var lineData = {};

                    var data = line.dataSlider.currentPeg.value;
                    if (WhistleOut.isNumber(data))
                        lineData.data = data;
                    else
                        lineData.data = null;

                    if (line.callsSlider) {
                        var calls = line.callsSlider.currentPeg.value;
                        if (WhistleOut.isNumber(calls))
                            lineData.calls = calls;
                    } else
                        line.calls = null;

                    if (line.minutesSlider) {
                        var minutes = line.minutesSlider.currentPeg.value;
                        if (WhistleOut.isNumber(minutes))
                            lineData.minutes = minutes;
                    } else
                        lineData.minutes = null;

                    var sms = line.messagesSlider.currentPeg.value;
                    if (WhistleOut.isNumber(sms))
                        lineData.sms = sms;
                    else
                        lineData.sms = null;

                    if (line.simOnly === true)
                        lineData.simOnly = true;
                    else
                        lineData.simOnly = null;

                    var phonePriceTypes = line.phonePriceTypes
                        .filter(function (priceType) {
                            return priceType.isChecked === true;
                        });

                    if (phonePriceTypes && phonePriceTypes.length > 0) {
                        lineData.phonePriceTypes = phonePriceTypes;
                    } else
                        lineData.phonePriceTypes = [];

                    lineData.allowPhoneSub = line.allowPhoneSub ? 1 : 0;
                    lineData.tetherPhone = line.tetherPhone ? 1 : 0;

                    var selectedPhone = line.selectedPhone;

                    if (selectedPhone) {
                        lineData.phone = selectedPhone.shortUrl;
                        lineData.phoneManufacturer = selectedPhone.manufacturerShortUrl;
                        if (selectedPhone.byod) {
                            lineData.byoPhoneModelId = selectedPhone.byod.id;
                        }
                    } else {
                        lineData.phone = null;
                        lineData.phoneManufacturer = null;
                    }

                    queryData.lines.push(lineData);
                });

            var maxUpfront = modalData.maxPhoneUpfrontSlider.currentPeg.value;
            if (WhistleOut.isNumber(maxUpfront))
                queryData.maxupfront = maxUpfront;
            else
                queryData.maxupfront = null;

            queryData.dealsonly = modalData.showDealsOnly;
            queryData.minSpend = modalData.monthlySpendSlider.currentPeg1.value;
            queryData.maxSpend = modalData.monthlySpendSlider.currentPeg2.value;

            queryData.suppliers = modalData.suppliers.filter(function (s) { return s.isChecked; })
                .map(function (s) { return s.shortUrl; });
            if (queryData.suppliers.length === queryData.allSuppliers.length)
                queryData.suppliers = [];

            queryData.network = modalData.networks.filter(function (n) { return n.isChecked; })
                .map(function (n) { return n.id; });
            if (queryData.network.length === modalData.networks.length)
                queryData.network = [];

            if (modalData.singleResultPerSupplier === true)
                queryData.singleResultPerSupplier = true;
            else
                queryData.singleResultPerSupplier = null;

            if (modalData.fullSpeedData === true)
                queryData.fullSpeedData = true;
            else if (modalData.fullSpeedData === false)
                queryData.fullSpeedData = false;

            if (modalData.includeSeniors === true)
                queryData.includeSeniors = true;
            else if (modalData.includeSeniors === false)
                queryData.includeSeniors = false;
            else
                queryData.includeSeniors = null;

            if (modalData.includeMilitary === true)
                queryData.includeMilitary = true;
            else if (modalData.includeMilitary === false)
                queryData.includeMilitary = false;
            else
                queryData.includeMilitary = null;

            if (modalData.eligibility)
                queryData.eligibility = modalData.eligibility;
            else
                queryData.eligibility = null;

            if (modalData.includeFirstResponders === true)
                queryData.includeFirstResponders = true;
            else if (modalData.includeFirstResponders === false)
                queryData.includeFirstResponders = false;
            else
                queryData.includeFirstResponders = null;

            if (modalData.includeInternationalCalls === true)
                queryData.includeInternationalCalls = true;
            else
                queryData.includeInternationalCalls = false;

            var selectedSupplier = modalData.allSuppliers.filter(function (supplier) {
                return supplier.isChecked === true;
            })[0];

            if (selectedSupplier) {
                queryData.currentsupplier = selectedSupplier.shortUrl;
                queryData.currentsupplierid = selectedSupplier.id;
            } else {
                queryData.currentsupplier = null;
                queryData.currentsupplierid = null;
            }

            var selectedContractType = modalData.tabs.filter(function (contractType) {
                return contractType.isChecked === true;
            })[0];

            if (selectedContractType) {
                queryData.tab = selectedContractType.key;
            } else
                queryData.tab = modalData.currentTab;

            if (modalData.customerType) {
                queryData.customer = modalData.customerType;

                if (modalData.customerType === 'Personal' &&
                        queryData.suppliers &&
                        queryData.suppliers.length > 0) {
                    var allPersonalSuppliers = modalData.allSuppliers.filter(function (s) { return s.isPersonal; })
                        .map(function (s) { return s.shortUrl; });
                        // Selected all personal suppliers only
                    if (wo$(allPersonalSuppliers).not(queryData.suppliers).length === 0 &&
                            wo$(queryData.suppliers).not(allPersonalSuppliers).length === 0) {
                        queryData.suppliers = [];
                    }
                } else if (modalData.customerType === 'Business' &&
                        queryData.suppliers &&
                        queryData.suppliers.length > 0) {
                    var allBusinessSuppliers = modalData.allSuppliers.filter(function (s) { return s.isBusiness; })
                        .map(function (s) { return s.shortUrl; });
                        // Selected all personal suppliers only
                    if (wo$(allBusinessSuppliers).not(queryData.suppliers).length === 0 &&
                            wo$(queryData.suppliers).not(allBusinessSuppliers).length === 0) {
                        queryData.suppliers = [];
                    }
                }
            } else
                queryData.customer = null;

            var selectedSortExpression = modalData.sortExpressions.filter(function (sortExpression) {
                return sortExpression.isChecked === true;
            })[0];

            if (selectedSortExpression) {
                queryData.sortExpression = selectedSortExpression.key.replace('-desc', '');
                queryData.sortAscending = selectedSortExpression.isAscending;
            } else {
                queryData.sortExpression = null;
                queryData.sortAscending = true;
            }

            if (modalData.prepaidExpirySlider.currentPeg1.value !== modalData.prepaidExpirySlider.pegs[0].value) {
                queryData.prepaidExpiry = modalData.prepaidExpirySlider.currentPeg1.value;
            } else {
                queryData.prepaidExpiry = null;
            }

            if (modalData.prepaidExpirySlider.currentPeg2.value !==
                    modalData.prepaidExpirySlider.pegs[modalData.prepaidExpirySlider.pegs.length - 1].value) {
                queryData.maximumPrepaidExpiry = modalData.prepaidExpirySlider.currentPeg2.value;
            } else {
                queryData.maximumPrepaidExpiry = null;
            }

            queryData.planTypes = modalData.planTypes;
            queryData.products = modalData.products;
            queryData.refurbishedPhones = modalData.refurbishedPhones;

            queryData.page = null;

            filtersModal.modal('hide');
            wo$('body').removeClass('modal-open');
            wo$('.modal-backdrop').remove();

            WhistleOut.notifications.fire('FilterChanged', { type: 'Lines', criteria: queryData });

            // Scroll To Top
            if (wo$ !== undefined && wo$) {
                WhistleOut.scrollTo('.navbar', 500);
            }
        },

        init: function () {
            filtersModal = wo$('#refine-modal');
            if (!filtersModal.length) return;

            modalBackup = filtersModal.clone().html();
            modalDataBackup = wo$.extend(true, {}, WhistleOut.readLookupData(filtersModal.parent()));
            modalData = WhistleOut.readLookupData(filtersModal.parent());

            filtersModalController.bind();
        }
    };

    const init = debounce(filtersModalController.init, 300);

    // 'FiltersModalReady' can be fired before the controller is initialised,
    // so we need to make sure init() is called on initial load
    init();

    WhistleOut.notifications.add(function (notification) {
        if (notification === 'FiltersModalReady') {
            init();
        }
    });
}

WhistleOut.initModule(import.meta.url, main);